// Path: src\Components\HtmlFreeGames\HtmlPopUp.jsx
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { getHTMLGameListByCategory, updateView } from "../../api/htmlFreeGames";

const HtmlPopUp = ({ setHtmlPopUp, HtmlGameData }) => {
  const { t } = useTranslation();
  const joinHtmlGame = (data) => {
    console.log()
  };

  const handleJoinButtonClick = (data) => {
    localStorage.setItem("DirectLink", data?.url)
    setHtmlPopUp(false)
    window.location.href = `/htmlFreeGames/game/${data._id}`
  }

  return (
    <div className="popupinner-wrapper">
      <div className="popup-overlay">
        <div className="popup-container">
          <button
            className="close-btn"
            onClick={() => {
              setHtmlPopUp(false);
            }}
          >
            <svg
              width="32"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g opacity="0.8" filter="url(#filter0_b_2731_8186)">
                <circle
                  cx="16"
                  cy="16"
                  r="16"
                  fill="#82838E"
                  fill-opacity="0.5"
                />
              </g>
              <rect
                x="12.0531"
                y="10.9065"
                width="13.3333"
                height="1.96078"
                rx="0.980392"
                transform="rotate(45 12.0531 10.9065)"
                fill="#F4F4F4"
              />
              <rect
                x="10.6666"
                y="20.3345"
                width="13.3333"
                height="1.96078"
                rx="0.980392"
                transform="rotate(-45 10.6666 20.3345)"
                fill="#F4F4F4"
              />
              <defs>
                <filter
                  id="filter0_b_2731_8186"
                  x="-24"
                  y="-24"
                  width="80"
                  height="80"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feGaussianBlur
                    in="BackgroundImageFix"
                    stdDeviation="12"
                  />
                  <feComposite
                    in2="SourceAlpha"
                    operator="in"
                    result="effect1_backgroundBlur_2731_8186"
                  />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect1_backgroundBlur_2731_8186"
                    result="shape"
                  />
                </filter>
              </defs>
            </svg>
          </button>
          <h2 className="popup-header w-100">{localStorage?.getItem("activeFreeGame") +" - "+ HtmlGameData.name}</h2>
          <div className="tournament-joining-popup-confirmationbox" style={{ padding: "1rem ", marginTop: "3rem ",borderBlockEnd: "solid 1px white" }}>
            <div className="tournament-joining-popup-confirmation-title">
              confirmation
            </div>
          </div>
          <div className="" style={{ display: "flex", flexFlow: 'row', justifyContent: "space-between", padding: "1rem ",borderBlockEnd:"solid 1px white" }}>
            <div className="">Entry Fee</div>
            <div className="">Free</div>
          </div>

          <div className="" style={{ display: "flex", flexFlow: 'row', justifyContent: "center", padding: "1rem" }}>
            Enjoy Free Games on Vodafone Idea
          </div>

           
            
                <div className="">
                  <button
                    className="submit-button"
                    type="button"
                    onClick={() => {
                      handleJoinButtonClick(HtmlGameData);
                    }}
                  >
                    {`JOIN GAME`}
                  </button>
              
             
            </div>
          </div>
        </div>
      </div>
      );
};

      export default HtmlPopUp;
